module.exports = __webpack_public_path__ + "img/pringels.d0772d02.jpg";